module.exports = (function () {
    const wrap = (element, wrapperElement) => {
        element.parentNode.insertBefore(wrapperElement, element);
        wrapperElement.appendChild(element);
    }
    return (textElement) => {
        const iframes = textElement.querySelectorAll('iframe');
        const blockQuotes = textElement.querySelectorAll('blockquote');
        const tableElements = textElement.querySelectorAll('table');
        iframes.forEach((iframe) => {
            if (iframe.parentNode && iframe.parentNode.classList.contains('iframe-wrapper')) {
                return;
            }
            const wrapper = document.createElement('div');
            wrapper.classList.add('iframe-wrapper');
            iframe.parentNode.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
        });
        blockQuotes.forEach((blockQuote) => {
            if (blockQuote.parentNode && blockQuote.parentNode.classList.contains('blockquote-wrapper')) {
                return;
            }
            const wrapper = document.createElement('div');
            wrapper.classList.add('blockquote-wrapper');

            blockQuote.parentNode.insertBefore(wrapper, blockQuote);
            wrapper.appendChild(blockQuote);
        });
        for (const tableElement of tableElements) {
            const wrapperElement = document.createElement('div');
            wrapperElement.classList.add('table-wrapper');
            wrap(tableElement, wrapperElement);
        }
    };
})();